import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { DocumentRangeAttributes } from '@albatrosdeveloper/ave-models-package';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { DocumentRangeService } from '../document-range.service';
import { DOCUMENT_RANGE_EXPORT_ID, DOCUMENT_RANGE_TITLE, LOCALIZED_PROPERTIES } from './document-range.constants';

@Injectable()
export class DocumentRangeExport {
  constructor(
    private exportService: ExportService,
    private documentRangeService: DocumentRangeService,
  ) {}
//cambiar atributo
  private transformItem(item: DocumentRangeAttributes) {
    return {
      code: get(item, 'code', ''),
      emissionPoint: get(item, 'emissionPoint.name', ''),
      dateTimeStart: ExportTaskProcessor.types.excel.datetime(get(item, 'dateTimeStart', null)),
      dateTimeEnd: ExportTaskProcessor.types.excel.datetime(get(item, 'dateTimeEnd', null)),
      leftFormat: get(item, 'leftFormat', ''),
      rightFormat: get(item, 'rightFormat', ''),
      authorizationNumber: get(item, 'authorizationNumber', ''),
      documentType: `${get(item, 'documentType.code', '')}-${get(item, 'documentType.name', '')}`,
      documentClass: `${get(item, 'documentClass.code', '')}-${get(item, 'documentClass.name', '')}`,
      lowerLimit: get(item, 'lowerLimit', ''),
      upperLimit: get(item, 'upperLimit', ''),
      initialValue: get(item, 'initialValue', ''),
      currentValue: get(item, 'currentValue', ''),
      email: get(item, 'email', ''),
      notifyAfter: ExportTaskProcessor.types.excel.date(get(item, 'notifyAfter', null)),
      notifyWhenReachNumber: get(item, 'notifyWhenReachNumber', ''),
    };
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: DOCUMENT_RANGE_EXPORT_ID,
      title: DOCUMENT_RANGE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(DOCUMENT_RANGE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.documentRangeService.findByFilter(buildQuery(
          seed(this.documentRangeService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(DOCUMENT_RANGE_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(DOCUMENT_RANGE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
